/**
 * hashes actions
 */
import SET_HASH from './constants';

export default function setHash(namespace: string, hash: string) {
    return {
        type: SET_HASH,
        payload: {
            namespace,
            hash
        }
    };
}
